export default __webpack_public_path__ + "static/media/hero-background.93e589c3.webp";